<mat-dialog-content>
  <div class="limit-modal">
    <div class="limit-header">
      <h3 class="limit-title">Dataset Submission Successful!</h3>
    </div>
    <div class="limit-body">
      <span tabindex="0">
        Your dataset has been successfully submitted.
        <b>It can take a few hours for your selected visualization to complete.</b>
        You can close this message and return to your dashboard to check the status. documents.
      </span>
    </div>
    <div class="limit-footer">
      <mat-dialog-actions>
        <button mat-raised-button class="close-button" color="primary" (click)="onSuccess()">Close</button>
      </mat-dialog-actions>
    </div>
  </div>
</mat-dialog-content>
